import { combineReducers } from 'redux';
import activeType from './active-type';
import domainFields, * as fromDomainFields from './domain-fields';

export interface DomainState {
  activeType: string;
  fields: fromDomainFields.DomainFields;
}

export function getFieldValue(state: DomainState, fieldName: string): string {
  if (!state) {
    return null;
  }
  return fromDomainFields.getValue(state.fields, fieldName);
}

export default combineReducers({
  activeType,
  fields: domainFields,
});
